import axios from "axios";
import Api from "../Api/Api.json";

class SchoolService {
  constructor() {
    this.baseURL = Api.SPOKEN_ENGLISH_USER_API;
    this.headers = { "Content-Type": "application/json" };
  }

  async getSubjectProblemList(level, subject, medium) {
    const requestData = {
      task: "getSubjectProblemList",
      level: level,
      subject: subject,
      medium: medium,
    };
    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });
    return response.data;
  }

  async getProblems(
    user_id,
    level,
    subject,
    medium,
    chapter,
    section,
    problem_no
  ) {
    const requestData = {
      task: "getProblems",
      user_id: user_id,
      level: level,
      subject: subject,
      medium: medium,
      chapter: chapter,
      section: section,
      problem_no: problem_no,
    };
    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });
    return response.data;
  }

  async analyzeSchoolAnswer(
    problem,
    solution,
    level,
    subject,
    medium,
    chapter,
    section,
    problem_no,
    sub_problem_no,
    concept,
    user_id,
    user_response
  ) {
    const requestData = {
      task: "analyzeSchoolAnswer",
      problem: problem,
      solution: solution,
      level: level,
      subject: subject,
      medium: medium,
      chapter: chapter,
      section: section,
      problem_no: problem_no,
      sub_problem_no: sub_problem_no,
      concept: concept,
      user_id: user_id,
      user_response: user_response,
    };
    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });
    return response.data;
  }
}

export const schoolService = new SchoolService();
